const choices = {
    owner: 'Propriétaire(s)',
    tenant: 'Locataire(s)',
    companyAccomodation: 'Logement de fonction',
    freeAccomodation: 'Logé(s) à titre gratuit',
};

export default choices;
